import React, { useState, useCallback } from 'react';
import { atualizarIniciativa } from 'services/iniciativa-premio.service';
import { CATEGORIAS_INICIATIVAS_OFICIAIS, normalizeCategoryPremio } from 'utils/iniciativa-categoria';

interface ModalEditarCategoriaProps {
  iniciativaOriginal: any;
  onSave: () => void;
  onClose: () => void;
}

export const ModalEditarCategoria: React.FC<ModalEditarCategoriaProps> = ({
  iniciativaOriginal,
  onSave,
  onClose,
}) => {
  const [categoryPremio, setCategoryPremio] = useState(
    normalizeCategoryPremio(iniciativaOriginal?.categoryPremio) || ''
  );
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSave = useCallback(async () => {
    setIsSaving(true);
    setError('');
    try {
      await atualizarIniciativa({
        ...iniciativaOriginal,
        categoryPremio,
      });
      onSave();
    } catch (err) {
      console.error('Erro ao atualizar categoria:', err);
      setError('Erro ao salvar categoria. Tente novamente.');
    } finally {
      setIsSaving(false);
    }
  }, [categoryPremio, iniciativaOriginal, onSave]);

  return (
    <div className="bg-white rounded-2xl p-5 w-[480px] max-w-[90vw]">
      <h2 className="text-lg font-bold text-[#1e3a5f] mb-4">Editar Categoria</h2>

      <div className="mb-4">
        <label className="block text-sm font-semibold text-gray-700 mb-1">
          Categoria
        </label>
        <select
          value={categoryPremio}
          onChange={(e) => setCategoryPremio(e.target.value)}
          className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-700 bg-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-bb"
        >
          <option value="" disabled>Selecione uma categoria</option>
          {CATEGORIAS_INICIATIVAS_OFICIAIS.filter((cat) => cat.id.startsWith('ECBB')).map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.label}
            </option>
          ))}
        </select>
      </div>

      {error && (
        <p className="text-red-500 text-sm mb-3">{error}</p>
      )}

      <div className="flex items-center justify-end gap-3">
        <button
          onClick={onClose}
          disabled={isSaving}
          className="bg-transparent border border-gray-300 text-gray-600 rounded-lg px-6 py-2.5 text-sm font-bold cursor-pointer hover:bg-gray-50 transition-colors disabled:opacity-40"
        >
          CANCELAR
        </button>
        <button
          onClick={handleSave}
          disabled={isSaving || !categoryPremio}
          className="bg-[#f5c518] text-[#1e3a5f] border-0 rounded-lg px-6 py-2.5 text-sm font-extrabold cursor-pointer hover:bg-[#e6b800] transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        >
          {isSaving ? 'SALVANDO...' : 'SALVAR ALTERAÇÕES'}
        </button>
      </div>
    </div>
  );
};
